/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMonatsauswertungLayoutDto } from '../../models/create-monatsauswertung-layout-dto';
import { MonatsauswertungLayoutDto } from '../../models/monatsauswertung-layout-dto';

export interface UpdateMonatsauswertungLayout$Plain$Params {
  id: string;
      body?: CreateMonatsauswertungLayoutDto
}

export function updateMonatsauswertungLayout$Plain(http: HttpClient, rootUrl: string, params: UpdateMonatsauswertungLayout$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MonatsauswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, updateMonatsauswertungLayout$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonatsauswertungLayoutDto>;
    })
  );
}

updateMonatsauswertungLayout$Plain.PATH = '/v1/monatsauswertungen/layouts/{id}';
